/**
 *
 * @file 项目管理api
 **/

import AXIOS from '@/utils/$axios';

// 项目列表
export const queryProductList = payload =>
    AXIOS.post(`/space/enterprise/project/project-space`, payload);

// 删除项目 (pro)
export const removeProject = payload => {
    return AXIOS.post('/space/enterprise/project/delete', payload);
};

// 重命名项目(pro)
export const renameProject = payload => {
    return AXIOS.post('/space/enterprise/project/rechristen', payload);
};

//  退出项目
export const exitProject = payload => {
    return AXIOS.post('/space/project/common/exit-project', payload);
};

// 查询设置指引状态
export const getUserGuidance = params => {
    return AXIOS.get('/space/user/guidance', { params });
};
// 查询用户是否需要指引
export const getProjectStatistics = payload => {
    return AXIOS.post('/space/project/project/project-statistics', payload);
};

export const getMockCreateProject = payload => {
    return AXIOS.post('/space/mock/create-project', payload);
};

export const tipJoinProject = payload => {
    return AXIOS.post(
        '/space/enterprise/organization/power/get-project-default-role',
        payload
    );
};
